import api from "src/apis/api";

function toQuery(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") q.set(key, value);
  });
  return q.toString();
}

export async function fetchSiteVisits(params = {}) {
  const { data } = await api.get(`/api/v1/site_visits?${toQuery(params)}`);
  return data.site_visits;
}

export async function fetchCalendar({ from, to, hostUserId, projectId, status } = {}) {
  const query = toQuery({
    from,
    to,
    host_user_id: hostUserId,
    project_id: projectId,
    status,
  });
  const { data } = await api.get(`/api/v1/site_visits/calendar?${query}`);
  return data;
}

export async function fetchSiteVisit(id) {
  const { data } = await api.get(`/api/v1/site_visits/${id}`);
  return data;
}

export async function scheduleSiteVisit({
  leadId,
  hostUserId,
  scheduledAt,
  durationMinutes,
  projectId,
  dealId,
  notes,
}) {
  const { data } = await api.post("/api/v1/site_visits", {
    lead_id: leadId,
    host_user_id: hostUserId,
    scheduled_at: scheduledAt,
    duration_minutes: durationMinutes,
    project_id: projectId,
    deal_id: dealId,
    notes,
  });
  return data;
}

export async function rescheduleSiteVisit(id, scheduledAt) {
  const { data } = await api.post(`/api/v1/site_visits/${id}/reschedule`, {
    scheduled_at: scheduledAt,
  });
  return data;
}

export async function confirmSiteVisit(id) {
  const { data } = await api.post(`/api/v1/site_visits/${id}/confirm`);
  return data;
}

export async function cancelSiteVisit(id, reason) {
  const { data } = await api.post(`/api/v1/site_visits/${id}/cancel`, { reason });
  return data;
}

export async function checkInSiteVisit(
  id,
  { latitude, longitude, accuracyMeters, selfieBlob, override } = {}
) {
  const formData = new FormData();
  if (latitude != null) formData.append("latitude", latitude);
  if (longitude != null) formData.append("longitude", longitude);
  if (accuracyMeters != null) formData.append("accuracy_meters", accuracyMeters);
  if (override) formData.append("override", "true");
  if (selfieBlob) formData.append("selfie", selfieBlob, "checkin.jpg");

  const { data } = await api.post(`/api/v1/site_visits/${id}/check_in`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function completeSiteVisit(
  id,
  { outcome, rating, feedbackNotes, budgetFeedback } = {}
) {
  const { data } = await api.post(`/api/v1/site_visits/${id}/complete`, {
    outcome,
    rating,
    feedback_notes: feedbackNotes,
    budget_feedback: budgetFeedback,
  });
  return data;
}
